var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-relative",staticStyle:{"min-height":"240px"}},[_c('v-overlay',{attrs:{"absolute":"","value":_vm.isFetching}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":70,"color":"white"}})],1),_c('bar-chart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }